import { render, staticRenderFns } from "./ManagerSettingsAvatar.vue?vue&type=template&id=2226c645&scoped=true"
import script from "./ManagerSettingsAvatar.vue?vue&type=script&lang=js"
export * from "./ManagerSettingsAvatar.vue?vue&type=script&lang=js"
import style0 from "./ManagerSettingsAvatar.vue?vue&type=style&index=0&id=2226c645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226c645",
  null
  
)

export default component.exports